<template>
  <div>
    <v-timeline
      v-if="items.length"
      dense
    >
      <timeline-item-base
        v-for="(item, indice) in items"
        :key="indice"
        :item="item"
        :indice="indice"
      >
        <template #title>
          Status: {{ item.statusNome }}
        </template>

        <template #subtitle>
          Alterado por: {{ item.nomeUsuarioAlteracao }}
        </template>
      </timeline-item-base>
    </v-timeline>

    <h4 v-else>
      Nenhum item disponível
    </h4>
  </div>
</template>

<script>
import TimelineBase from './TimelineBase.vue'
import TimelineItemBase from './TimelineItemBase.vue'

export default {
  components: {
    TimelineItemBase,
  },

  extends: TimelineBase,
}
</script>
